import * as tslib_1 from "tslib";
import { utils } from '@cloudpivot/common';
import { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE } from './is-platform';
import { BrowserService } from './platform-service';
// import { DingTalkService } from './dingtalk/dingtalk-service';
import { Base64 } from 'js-base64';
function parseToken(token) {
    const useInfoBs = token.split('.')[1];
    const useInfo = JSON.parse(Base64.decode(useInfoBs));
    return useInfo;
}
export { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE };
let service = new BrowserService();
export function start(client_id, scope) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let _service = null;
        const query = utils.parseQuery();
        let loginInfo;
        let p = null;
        if (IS_DEBUG) {
        }
        else {
            if (IS_DINGTALK) {
                const dingtalk = yield import(/* webpackChunkName: "dingtalk" */ './dingtalk');
                p = dingtalk.init(client_id, scope, query);
                _service = new dingtalk.DingTalkService();
            }
        }
        if (_service) {
            service = _service;
        }
        if (p) {
            const res = yield p;
            if (res) {
                const { access_token, userinfo, refresh_token, expiration } = res;
                loginInfo = res;
                const info = parseToken(access_token);
                if (info) {
                    const user = userinfo;
                    user.isAppAdmin = info.isAppAdmin;
                    user.isAdmin = info.isAdmin;
                }
                sessionStorage.setItem('user', JSON.stringify(userinfo));
                localStorage.setItem('token', access_token);
                localStorage.setItem('refresh_token', JSON.stringify(refresh_token));
                localStorage.setItem('expireTime', `${expiration}`);
            }
        }
        else {
            if (query.access_token) {
                localStorage.setItem('token', query.access_token);
            }
        }
        return {
            query,
            loginInfo
        };
    });
}
export { service };
